<template>
  <el-table-column
    prop="category.name"
    sortable="custom"
    label="Kategória"
    show-overflow-tooltip
    min-width="110"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.category">{{ scope.row.category.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'category.name',
  };
</script>
